import { render, staticRenderFns } from "./RoomProxy.vue?vue&type=template&id=736fdfee&"
import script from "./RoomProxy.vue?vue&type=script&lang=js&"
export * from "./RoomProxy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('736fdfee')) {
      api.createRecord('736fdfee', component.options)
    } else {
      api.reload('736fdfee', component.options)
    }
    module.hot.accept("./RoomProxy.vue?vue&type=template&id=736fdfee&", function () {
      api.rerender('736fdfee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/RoomProxy.vue"
export default component.exports